import React from "react"
import * as Icon from "react-feather"

const horizontalMenuBranchConfig = [
   {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      icon: <Icon.Home size={16}/>,
      navLink: "/",
   },
   {
      id: "branch-receive",
      title: "Receive",
      type: "dropdown",
      icon: <Icon.Truck size={16}/>,
      children: [
         {
            id: "receive-product",
            title: "Receive Product",
            type: "item",
            icon: <Icon.Book size={16}/>,
            navLink: "/receive-product",
            permissions: ["admin", "super","branch"]
         }
      ]
   },
   {
      id: "branch-sales",
      title: "Sales",
      type: "dropdown",
      icon: <Icon.Package size={16}/>,
      children: [
         {
            id: "sales-product",
            title: "Sales Product",
            type: "item",
            icon: <Icon.Inbox size={16}/>,
            navLink: "/sales-product",
            permissions: ["admin", "super","branch"]
         }
      ]
   },
   {
      id: "settings",
      title: "Settings",
      type: "dropdown",
      icon: <Icon.Settings size={16}/>,
      children: [
         {
            id: "accountSettings",
            title: "Account Settings",
            type: "item",
            icon: <Icon.Settings size={16}/>,
            navLink: "/account-settings",
            // permissions: ["branch"]
         },
         {
            id: 'logout',
            title: 'Logout',
            icon: <Icon.LogOut size={16}/>,
            type: 'item',
            navLink: '/logout'
         }
      ]
   },
]

export default horizontalMenuBranchConfig
